var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPhotogallery = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#4d4c4d",
  d: "M31.627 39.108H8.372a7.48 7.48 0 0 1-7.48-7.48V8.371a7.48 7.48 0 0 1 7.48-7.48h23.255a7.48 7.48 0 0 1 7.481 7.48v23.255a7.48 7.48 0 0 1-7.48 7.481"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m13.607 22.643 3.143-4.072 2.286 2.643 3.428-3.857 3.93 5.286zm14.1-9.358H12.294a1.88 1.88 0 0 0-1.878 1.878v9.674c0 1.037.841 1.878 1.878 1.878h15.413a1.877 1.877 0 0 0 1.876-1.878v-9.674c0-1.037-.84-1.878-1.876-1.878"
}))));
export default SvgPhotogallery;